<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :opacity="opacity">
      <path d="M17.1421 6.14999C17.0145 6.01666 16.8551 6.00001 16.6957 6.00001H13.3478V4.00001C13.3478 3.63334 13.029 3.33334 12.6783 3.33334H7.32175C6.97103 3.33334 6.65219 3.63334 6.65219 4.00001V6.00001H3.30437C2.95364 6.00001 2.66669 6.21668 2.66669 6.58334V16C2.66669 16.3667 2.95364 16.6667 3.30437 16.6667H16.6957C17.0464 16.6667 17.3334 16.3667 17.3334 16V6.61667C17.3334 6.43333 17.2696 6.28333 17.1421 6.14999ZM7.92756 4.66668H12.0725V6.00001H7.92756V4.66668ZM16.058 7.33334V10.8333H11.5942V10.5833C11.5942 10.3 11.3391 10.1667 11.0681 10.1667H8.91596C8.64494 10.1667 8.38988 10.3167 8.38988 10.5833V10.8333H3.92611V7.33334H16.058ZM10.6377 11.1667V11.5H9.36234V11.1667H10.6377ZM3.94205 15.3333V11.8333H8.40582V12C8.40582 12.2833 8.6609 12.5 8.93191 12.5H11.0841C11.3551 12.5 11.6102 12.2667 11.6102 12V11.8333H16.0739V15.3333H3.94205Z" :fill="fillColor"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "thingIcon",
    props: {
      fillColor: {
        type: String,
        default: '#00527F'
      },
      opacity: {
        type: String,
        default: '0.4'
      }
    }
  }
</script>

<style scoped>

</style>
